import { render, staticRenderFns } from "./AdsAccountEdit.vue?vue&type=template&id=271f15e6&"
import script from "./AdsAccountEdit.vue?vue&type=script&lang=js&"
export * from "./AdsAccountEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports